import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

let auth = null;
let db   = null;

try {
  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db   = getFirestore(app);
} catch (e) {
  console.warn('Firebase not initialized — set REACT_APP_FIREBASE_* env vars to enable the distributor portal.');
}

export { auth, db };

/*
=================================================================
FIREBASE SETUP — one-time steps
=================================================================

1. Go to console.firebase.google.com → Create project → "ntm-distributor"
   - Disable Google Analytics (not needed)

2. Add a Web App:
   Project Settings (gear icon) → Your Apps → </> Web
   App nickname: "NTM Distributor Portal"
   Copy the config values into frontend/.env

3. Enable Authentication:
   Build → Authentication → Get Started
   Sign-in method → Email/Password → Enable (top toggle ON)
   Leave "Email link" OFF

4. Enable Firestore:
   Build → Firestore Database → Create database
   Start in PRODUCTION mode → pick a region (us-east1 is fine) → Enable

5. Set Firestore Security Rules:
   Firestore → Rules tab → replace contents with:

   rules_version = '2';
   service cloud.firestore {
     match /databases/{database}/documents {
       match /user_profiles/{userId} {
         function isAdmin() {
           return request.auth != null &&
             get(/databases/$(database)/documents/user_profiles/$(request.auth.uid)).data.access_level == 'admin';
         }
         allow read:   if request.auth != null && (request.auth.uid == userId || isAdmin());
         allow create: if request.auth != null && request.auth.uid == userId;
         allow update: if isAdmin() ||
           (request.auth != null && request.auth.uid == userId &&
            !('access_level' in request.resource.data.diff(resource.data).affectedKeys()));
       }
     }
   }

   → Publish

6. Customize email templates (branding):
   Authentication → Templates
   - Change "From name" to: Nursetech Medical
   - Change "Reply-to" to: info@nursetechmedical.com
   - Edit the body of "Email address verification" and "Password reset"
     to say "Nursetech Medical" and include your site URL

7. Set password reset redirect URL:
   Authentication → Templates → Password reset → Edit
   Set "Action URL" to: https://nursetechmedical.com/distributors/reset-password

8. Create your admin account:
   Authentication → Users → Add user
   Email: your email, Password: your admin password
   Copy the UID, then in Firestore → user_profiles collection → Add document:
     Document ID: (your UID)
     Fields:
       full_name: "David Usevitch"
       company: "Nursetech Medical"
       access_level: "admin"
       created_at: (timestamp)

=================================================================
*/
